import { Routes } from '@angular/router';

export const matchesRoutes: Routes = [
  {
    path: 'matches',
    title: 'Matches',
    data: { title: 'Matches' },
    loadComponent: () => import('./pages/Home/Home.component').then((m) => m.HomeComponent),
  },
];
